import { render, staticRenderFns } from "./Entregadav.vue?vue&type=template&id=067c54f6&"
import script from "./Entregadav.vue?vue&type=script&lang=js&"
export * from "./Entregadav.vue?vue&type=script&lang=js&"
import style0 from "./Entregadav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports